import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: "AIzaSyCKy8p5HXeSEvEuqq6eo9gU9hh7THP-qaU",
    authDomain: "tobeai-cs.firebaseapp.com",
    projectId: "tobeai-cs",
    storageBucket: "tobeai-cs.firebasestorage.app",
    messagingSenderId: "523253512236",
    appId: "1:523253512236:web:ec4eed67c84e6d12843989",
    measurementId: "G-DBC4CGJ565"
};

// Firebase 앱 초기화
const app = initializeApp(firebaseConfig);

// Analytics 초기화
const analytics = getAnalytics(app);

// Firestore 및 Functions 초기화
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Cloud Functions URL (배포 후 실제 URL로 변경 필요)
const FUNCTIONS_BASE_URL = 'https://us-central1-tobeai-cs.cloudfunctions.net';

// 문의하기 HTTP 요청 함수 (사용자용)
export const submitInquiry = async (data) => {
    const response = await fetch(`${FUNCTIONS_BASE_URL}/submitInquiry`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || '문의 접수 중 오류가 발생했습니다.');
    }

    return response.json();
};

export default app; 